var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBAvatar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    className: "premiumIcon",
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0008 19.5H16.1228C18.0268 19.5 19.4548 18.52 19.4548 16.756C19.4548 15.622 18.6988 14.586 17.2428 14.39V14.362C18.1808 14.138 18.9508 13.424 18.9508 12.36C18.9508 10.75 17.6208 9.952 15.6468 9.952H13.0008V19.5ZM17.4388 16.588C17.4388 17.47 16.9068 17.988 15.9268 17.988H14.8908V15.23H15.8428C16.8648 15.23 17.4388 15.79 17.4388 16.588ZM16.9768 12.556C16.9768 13.298 16.5568 13.76 15.6188 13.76H14.8908V11.45H15.5488C16.4448 11.45 16.9768 11.842 16.9768 12.556Z",
    className: "premiumBackgroundText",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/B_Avatar.d3e525d61f9e5d4f132ee619140455ce.svg";